module.exports = __webpack_public_path__ + "img/p5-pic.34581e15.jpg";